// apps/web/src/data/landingMocks.ts

/** Curated visual stubs for landing v2. Replace each section with real
 *  backend data when /api/* endpoints exist. See spec § Open items for
 *  Sarah-blessed values to swap in before launch. */

export type RecentPull = {
  ago: string
  city: string
  cardId: 'the-fool' | 'the-magician' | 'the-high-priestess' | 'the-empress' | 'the-lovers'
        | 'the-tower' | 'the-star' | 'the-moon' | 'the-sun' | 'the-world' | 'death' | 'judgement'
  question: string
}

export const landingMocks = {
  // TODO(landing-v2): replace with /api/recent-pulls
  recentPulls: [
    { ago: '2 hr',  city: 'Sparks, NV',       cardId: 'the-lovers',         question: 'is this the right person?' },
    { ago: '7 hr',  city: 'Reno, NV',          cardId: 'the-star',           question: 'what do I need to hear right now?' },
    { ago: '11 hr', city: 'Carson City, NV',   cardId: 'the-empress',        question: 'how do I tend to myself this week?' },
    { ago: '1 d',   city: 'Truckee, CA',       cardId: 'the-magician',       question: 'is this the moment to begin?' },
    { ago: '2 d',   city: 'Portland, OR',      cardId: 'the-fool',           question: 'where am I being asked to leap?' },
    { ago: '3 d',   city: 'Boise, ID',         cardId: 'the-moon',           question: 'what am I not seeing?' },
  ] satisfies RecentPull[],

  // TODO(landing-v2): replace with /api/next-ceremony
  nextCeremony: {
    // A real future date for the countdown. Update before each launch window
    // until a real schedule is wired.
    startsAt: '2026-06-18T20:00:00-07:00',
    host: 'Adrienne',
    title: 'Breath of Gold opening circle',
  },

  // TODO(landing-v2): replace with /api/community-pulls
  communityPulls: [
    { initials: 'M.', cardId: 'the-star' as const,   note: 'felt seen' },
    { initials: 'A.', cardId: 'the-moon' as const,   note: 'reading the silence' },
    { initials: 'J.', cardId: 'the-sun' as const,    note: 'arriving' },
    { initials: 'K.', cardId: 'the-empress' as const, note: 'tending again' },
  ],

  // TODO(landing-v2): replace with curated reviews
  testimonials: [
    { initials: 'M.K.', quote: "I open the app on the bus and feel like I've already had a quiet hour with myself." },
    { initials: 'L.R.', quote: 'Sarah and Adrienne hold the room even on a recording. That has surprised me.' },
    { initials: 'D.S.', quote: "The first oracle app that doesn't feel like a casino." },
    { initials: 'C.A.', quote: 'A small daily practice that has become a hinge in my week.' },
  ],
} as const
